import { render, staticRenderFns } from "./HomeTitle.vue?vue&type=template&id=00ca7a64&lang=pug&"
import script from "./HomeTitle.vue?vue&type=script&lang=js&"
export * from "./HomeTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports